/* ap-bundle-parent-guard.js (Apollo, 14 Sep 2026)
   Component-bundle placeholder products (Hyro Perform Variety HYPHPV30, Hyro Mixed Bundle HYPHBCLL30)
   must never reach the cart: the buybox on their PDP adds the component pouches instead. Some add
   paths bypass that buybox (legacy ap-buybox-us-au loaded via ?view=apollo-buybox on page-embedded
   pickers, search / collection quick-add, upsell widgets), which sold the raw parent SKU as a one-time
   line with no plan. This guard wraps window.fetch and rewrites any /cart/add(.js) request that
   contains a parent variant into the equivalent component lines (n parent -> n x A + n x B), tagged
   with the same _perform_bundle / _bundle_* properties the buybox uses so the cart drawer groups them
   and "Upgrade to AutoShip" works. Loaded in layout/theme.liquid before the cart handler. */
(function () {
  if (window.__apBundleParentGuard) return;
  window.__apBundleParentGuard = true;

  var PARENTS = {
    '55448518983979': { prefix: 'mb', title: 'Hyro Mixed Bundle', handle: 'hyro-mixed-bundle-bcll',
      a: { id: 51127606509867, role: 'Blackcurrant Crush' }, b: { id: 46832761176363, role: 'Lemon Lime' },
      plan30: '119366811947', plan60: '118651191595' },
    '53782068724011': { prefix: 'pv', title: 'Hyro Perform Variety', handle: 'hyro-perform-variety',
      a: { id: 53316556292395, role: 'Lemon Lime' }, b: { id: 53361822368043, role: 'Raspberry' },
      plan30: '116897120555', plan60: '118651191595' }
  };

  function isAddUrl(url) {
    try { var p = new URL(url, location.origin).pathname; return /\/cart\/add(\.js)?$/.test(p); } catch (e) { return false; }
  }
  function key(cfg) { return cfg.prefix + '-' + Date.now() + '-' + Math.floor(Math.random() * 1e6); }
  function expand(item) {
    var cfg = PARENTS[String(item.id)];
    if (!cfg) return null;
    var qty = parseInt(item.quantity, 10) || 1;
    var plan = item.selling_plan ? String(item.selling_plan) : '';
    var autoship = qty >= 2 ? cfg.plan60 : cfg.plan30;
    var k = key(cfg);
    var base = { _perform_bundle: k, _bundle_title: cfg.title, _bundle_handle: cfg.handle, _autoship_plan: plan || autoship, _ap_guard: '1' };
    function line(c, anchor) {
      var l = { id: c.id, quantity: qty, properties: Object.assign({ _bundle_role: c.role, _bundle_anchor: anchor }, base) };
      if (plan) l.selling_plan = plan;
      return l;
    }
    try { console.warn('[ap-bundle-guard] rewrote parent variant', item.id, 'x' + qty, '->', cfg.handle, 'components'); } catch (e) {}
    return [line(cfg.a, '1'), line(cfg.b, '0')];
  }
  function rewriteItems(items) {
    var out = [], changed = false;
    items.forEach(function (it) {
      var ex = expand(it);
      if (ex) { changed = true; out.push.apply(out, ex); } else out.push(it);
    });
    return changed ? out : null;
  }
  function formToItem(fd) {
    var item = { id: fd.get('id'), quantity: fd.get('quantity') || 1, properties: {} };
    if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m) item.properties[m[1]] = v; });
    return item;
  }
  function jsonHeaders(init) {
    var h = new Headers(init && init.headers || {});
    h.set('Content-Type', 'application/json'); h.set('Accept', 'application/json');
    return h;
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url);
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && isAddUrl(url) && init && init.body) {
        var body = init.body;
        if (typeof body === 'string') {
          var parsed = null; try { parsed = JSON.parse(body); } catch (e) {}
          if (parsed) {
            var items = parsed.items ? parsed.items : [{ id: parsed.id, quantity: parsed.quantity, selling_plan: parsed.selling_plan, properties: parsed.properties || {} }];
            var ri = rewriteItems(items);
            if (ri) {
              var nb = Object.assign({}, parsed, { items: ri }); delete nb.id; delete nb.quantity; delete nb.selling_plan; delete nb.properties;
              return origFetch.call(this, input, Object.assign({}, init, { body: JSON.stringify(nb), headers: jsonHeaders(init) }));
            }
          } else if (/(^|&)id=/.test(body)) {
            var params = new URLSearchParams(body);
            if (PARENTS[String(params.get('id'))]) {
              var fd0 = new FormData(); params.forEach(function (v, k) { fd0.append(k, v); });
              var ri0 = rewriteItems([formToItem(fd0)]);
              var nb0 = { items: ri0 };
              if (params.get('sections')) { nb0.sections = params.get('sections'); nb0.sections_url = params.get('sections_url') || location.pathname; }
              return origFetch.call(this, input, Object.assign({}, init, { body: JSON.stringify(nb0), headers: jsonHeaders(init) }));
            }
          }
        } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
          if (PARENTS[String(body.get('id'))]) {
            var ri2 = rewriteItems([formToItem(body)]);
            var nb2 = { items: ri2 };
            if (body.get('sections')) { nb2.sections = body.get('sections'); nb2.sections_url = body.get('sections_url') || location.pathname; }
            return origFetch.call(this, input, Object.assign({}, init, { body: JSON.stringify(nb2), headers: jsonHeaders(init) }));
          }
        }
      }
    } catch (e) { try { console.error('[ap-bundle-guard]', e); } catch (_) {} }
    return origFetch.apply(this, arguments);
  };

  /* Non-JS fallback: a plain <form action="/cart/add"> submit with a parent variant that NO other
     script handled. Registered on window (bubble) so every document-level handler (bundle buybox,
     nss-cart-handler) runs first; if any of them called preventDefault, or the form belongs to the
     bundle buybox (which adds the components itself), do nothing. 21 Sep 2026: the previous
     document/capture version fired before the buybox handler and double-added OTP pouches. */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || !isAddUrl(f.action)) return;
    if (e.defaultPrevented) return;
    if (f.closest && f.closest('nss-buybox')) return;
    var idEl = f.querySelector('[name="id"]');
    if (!idEl || !PARENTS[String(idEl.value)]) return;
    e.preventDefault();
    var items = rewriteItems([formToItem(new FormData(f))]);
    origFetch(location.origin + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function () { location.href = '/cart'; });
  }, false);
})();
